export default "__VITE_ASSET__c9WmH1XZ__"